export default {
  'menu.management.affiliate-system': 'Affiliate System',
  'menu.management.game.top-ranks': 'Rank Management',
};
